var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  };
  return __assign.apply(this, arguments);
};

var defaultOptions = {
  once: false,
  threshold: 0,
};
var buildOptions = function (options) {
  return __assign(__assign({}, defaultOptions), options);
};
var observe = function (target, observer) {
  var targets = target instanceof Element ? [target] : target;
  for (var i = 0; i < targets.length; i++) {
      observer.observe(targets[i]);
  }
};
var createObserver = function (callback, options, condition) {
  var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
          var target = entry.target;
          if (entry.rootBounds !== null && condition(entry)) {
              callback(target, {
                  isAboveView: entry.boundingClientRect.bottom < entry.rootBounds.height / 2 && entry.boundingClientRect.top < 0,
                  isInView: entry.isIntersecting,
                  isBelowView: entry.boundingClientRect.top > entry.rootBounds.height / 2 && entry.boundingClientRect.bottom > entry.rootBounds.height,
              });
              if (options.once) {
                  observer.unobserve(target);
              }
          }
      });
  }, {
      threshold: options.threshold,
  });
  return observer;
};
function isSupported() {
  return 'IntersectionObserver' in window;
}
var isInView = function (target, callback, options) {
  if (options === void 0) { options = {}; }
  var completeOptions = buildOptions(options);
  var observer = createObserver(callback, completeOptions, function (entry) { return entry.isIntersecting; });
  observe(target, observer);
};
var isOutOfView = function (target, callback, options) {
  if (options === void 0) { options = {}; }
  var completeOptions = buildOptions(options);
  var observer = createObserver(callback, completeOptions, function (entry) { return !entry.isIntersecting; });
  observe(target, observer);
};

//# sourceMappingURL=index.es.js.map

;// CONCATENATED MODULE: ./node_modules/async-wait-until/dist/index.esm.js
class e extends Error{constructor(t){super(null!=t?`Timed out after waiting for ${t} ms`:"Timed out"),Object.setPrototypeOf(this,e.prototype)}}const t=(e,t)=>new Promise(((o,n)=>{try{e.schedule(o,t)}catch(e){n(e)}})),o={schedule:(e,t)=>{let o;const n=e=>{null!=e&&clearTimeout(e),o=void 0};return o=setTimeout((()=>{n(o),e()}),t),{cancel:()=>n(o)}}},n=50,r=5e3,c=Number.POSITIVE_INFINITY,l=(n,r,l)=>{var s,u;const i=null!==(s="number"==typeof r?r:null==r?void 0:r.timeout)&&void 0!==s?s:5e3,a=null!==(u="number"==typeof r?l:null==r?void 0:r.intervalBetweenAttempts)&&void 0!==u?u:50;let m=!1;const d=()=>new Promise(((e,r)=>{const c=()=>{m||new Promise(((e,t)=>{try{e(n())}catch(e){t(e)}})).then((n=>{n?e(n):t(o,a).then(c).catch(r)})).catch(r)};c()})),h=i!==c?()=>t(o,i).then((()=>{throw m=!0,new e(i)})):void 0;return null!=h?Promise.race([d(),h()]):d()};//# sourceMappingURL=index.esm.js.map

;// CONCATENATED MODULE: ./src/js/packages/section-slideshow.js

if (!customElements.get('image-slideshow')) {
  class SlideshowComponent extends HTMLElement {
    constructor() {
      super();

      this.slideshow = this.querySelector('.splide');
      this.slideshowList = this.slideshow.querySelector('.splide__list');

      this.initSlideshow();
    }

    initSlideshow() {
      this.options = JSON.parse(this.slideshow.dataset.options);

      this.Splide = new theme.Splide(this.slideshow, this.options);

      this.Splide.on('moved', (index, prev, dest) => {
        let indexId = index + 1;
        if (indexId < 10) {
          indexId = `0${indexId}`;
        }

        const destSlide = this.slideshow.querySelector(
          `#${this.Splide.root.id}-slide${indexId}`
        );
        const destSlideImage = destSlide.querySelector('.slide__image');
        this.slideshowList.style.height = `${destSlideImage.offsetHeight}px`;
      });

      this.Splide.on('mounted', () => {
        this.onResize();
      });

      this.Splide.mount();

      this.bindEditorEvents();
    }

    onResize() {
      this.slideshowResizeObserver = new ResizeObserver((entries) => {      
        const activeSlideImage = this.slideshow.querySelector(
          '.splide__slide.is-active .slide__image'
        );
        if ( this.Splide.state.is( theme.Splide.STATES.IDLE ) ) {
          this.slideshowList.style.height = `${activeSlideImage.offsetHeight}px`;
        }
      });

      this.slideshowResizeObserver.observe(this.slideshow);
    }
 
    bindEditorEvents() {
      const {Autoplay} = this.Splide.Components;

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const selectedBlock = this.slideshow.querySelector(
          `[data-block-id="${blockId}"]`
        );
        if (selectedBlock) {
          const slideIndex = Number(selectedBlock.dataset.slideIndex);
          this.Splide.go(slideIndex);
        }
      });

      document.addEventListener('shopify:section:select', (event) => {
        Autoplay.pause();
      });

      document.addEventListener('shopify:section:deselect', (event) => {
        Autoplay.play();
      });
    }
  }
  customElements.define('image-slideshow', SlideshowComponent);
}
